export const callContacts = [
  { contact: 'Northwind Traders', number: '+1 415 555 0142' },
  { contact: 'Unknown caller', number: '+1 646 555 0104' },
  { contact: 'Brightline Co.', number: '+1 312 555 0193' },
  { contact: 'Helios Energy', number: '+1 212 555 0118' },
  { contact: 'Mira Holt', number: '+1 480 555 0145' },
  { contact: 'Atlas Freight', number: '+1 305 555 0173' },
  { contact: 'Summit Health', number: '+1 615 555 0147' },
  { contact: 'Paula Moreno', number: '+1 786 555 0128' },
  { contact: 'Crescent Bank', number: '+1 214 555 0185' },
  { contact: 'Harbor Dental', number: '+1 408 555 0138' },
  { contact: 'Lumen Studio', number: '+1 323 555 0161' },
  { contact: 'Ben Carver', number: '+1 669 555 0174' },
  { contact: 'Pinecrest Realty', number: '+1 360 555 0152' },
  { contact: 'Owen Price', number: '+1 629 555 0110' },
];
